$(document).ready(function(){

  $('.m-menu').click(function(){
    $('html, body').toggleClass('noscroll');
    $('body').toggleClass('m-menu-open');
  });

  $('.alert .close').click(function(){
    $(this).parent().remove();
    $('body').removeClass('w-alert');
    $('.agenda').css({'paddingTop':40})
  })

  /*
  $('.home .item').not('.label').mouseover(function(){
    $('.home .item').addClass('sleep');
    $(this).removeClass('sleep')
  })
  */

  $('.fancy-close').click(function(){
    parent.$.fancybox.close();
  })

  $('.home .item').mouseover(function(){
    var bg = $(this).data('bg');
    var url = $(this).attr('href');
    if(bg != undefined){
      $('.home .bg').css({"background-image":"url("+bg+")"});
    }
    if(url != undefined){
      $('.home .click-through').click(function(){window.location = url});
    }else{
      $('.home .click-through').click(function(){window.location = '#'});
    }
  })

  // get first background image on homepage
  var bg = $('.agenda .item[data-bg]:first').data('bg');
  if(bg != undefined){
   $('.home .bg').css({"background-image":"url("+bg+")"});
  }

  // set the background URL on load
  if($('body').hasClass('home')){
    var url = $('.item:first-child').attr('href');
    $('.home .click-through').click(function(){window.location = url});

    if($('body').hasClass('w-alert')){
      window.onresize = adjustPaddingTop;
      adjustPaddingTop();
    }
    function adjustPaddingTop(){
      var bp = 74;
      var opt = 90;
      var alHeight = $('.alert').outerHeight();
      if(alHeight > bp){
        var newpt = (alHeight - bp) + opt;
      }else{
        var newpt = opt;
      }
      $('.agenda').css({'paddingTop':newpt});
    }
  }




  // interview page hacks
  if($('body').hasClass('interview-page')){

    // duplicate images on interview page for the mobile view
    $('.extra .big-img').each(function( index, value ) {
      var newParent = $('.img-ref').eq(index)
      if (newParent.length == 0) {
        newParent = $('.page-content .info')
      }else{
        newParent.html(''); // clean the parent
      }
      $(this).clone().appendTo(newParent);
    })

    function repositionStuff() {
      $('.info .ref').each(function( index, value ) {
        $(this).clone().appendTo($('.meta'));
        $(this).remove();
      })

      $('.sup').each(function( index, value ) {
        $('.meta .ref').eq(index).css({"top":$(value).offset().top+"px"})
      });

      if($(window).width() > 880){
        var prevEndPos = 0;
        var fixedImgCnt = $('.img-ref').length;
        var sideImgCnt = $('.extra .big-img').length;

        var fixedCnt = 0;
        $('.img-ref').each(function( index, value ) {
          var refPos = $(value).offset().top;
          if(refPos <= prevEndPos) {
            refPos = prevEndPos + 20;
          }
          $('.extra .big-img').eq(index).addClass('fixed').css({"top":refPos+"px"});
          prevEndPos = $('.extra .big-img').eq(index).position().top + $('.extra .big-img').eq(index).height();
          fixedCnt++;
        });

        // check if there are any images that are not referenced and put them beneath the last fixed one
        if(fixedCnt < sideImgCnt){
          $('.extra .big-img').not('.fixed').each(function( index, value ) {
          var refPos = prevEndPos + 20;
          $(this).addClass('fixed').css({"top":refPos+"px"});
          prevEndPos = $(this).position().top + $(this).height();
        });
        }
      }
    }
    repositionStuff();
    window.onresize = repositionStuff;
  }

  if($('body').hasClass('explore-bis-page')){
    $('.block:not(.empty)').click(function(){
      $(this).toggleClass('open');
    })
    $('.explore-cols a').click(function(e){e.stopPropagation()});
  }


});